import { useConversationManager } from "shared/concierge/conversations/context/ConversationManagerContext";

export const useCurrentUserId = (): string => {
    const manager = useConversationManager();
    return manager.currentUserId;
};
